import { http } from '@pendo/http';

export function fetchStars () {
    return http.get('/api/s/_SID_/star');
}

export function fetchStar ({ itemType, itemId }) {
    return http.get(`/api/s/_SID_/star/${itemType}/${itemId}`);
}

export function addStar ({ itemType, itemId }) {
    return http.put(`/api/s/_SID_/star/${itemType}/${itemId}`, {});
}

export function deleteStar ({ itemType, itemId }) {
    return http.delete(`/api/s/_SID_/star/${itemType}/${itemId}`);
}
